import React from "react";
import CssClasses from "./FullscreenModalPopup.css";

import beepMedium from "../../../assets/sounds/beep_medium.mp3";

const FullscreenModalPopup = props => {
  if (!props.message || props.message === "") {
    return null;
  }

  return (
    <div className={CssClasses.container}>
      <audio
        ref={sound => {
          this.beepMedium = sound;
        }}
      >
        <source src={beepMedium} type="audio/mpeg" />
      </audio>

      <div className={CssClasses.popupBox}>
        <div className={CssClasses.titleRow}>OBAVIJEST</div>
        <div className={CssClasses.contentRow}>{props.message}</div>
        <div className={CssClasses.btnRow}>
          <div
            className={CssClasses.btn}
            onClick={() => {
              //daj zvukic
              if (this.beepMedium) {
                //daj zvukic
                this.beepMedium.play();
              }

              props.btnOkClickCallback();
            }}
          >
            OK
          </div>
        </div>
      </div>
    </div>
  );
};

export default FullscreenModalPopup;



// WEBPACK FOOTER //
// ./src/Components/UI/FullscreenModalPopup/FullscreenModalPopup.js